import { createDeferredI18n } from "#/shared/composables/useI18n";

import fallbackMessages from "#/shared/i18n/frontend.epic_widget_launcher.json";

export const { i18n, ready: whenI18nReady } = createDeferredI18n({ key: "epic_widget_launcher", fallbackMessages });

/**
 * Translates an Epic widget launcher string. Keys are relative to `frontend.epic_widget_launcher`.
 *
 * @param {String} key
 * @param {Object} [values] - Interpolation values.
 * @returns {String}
 */
export function t(key, values) {
  return i18n.global.t(key, values);
}
